export default __webpack_public_path__ + "styles/adminPanel.54b0fc54583502e82a40cb29f229d0a3.css";